import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface ICreateUpdateProjectStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  buttons?: IStyle;
}

export interface ICreateUpdateProjectClassNames {
  root: string;
  form: string;
  fields: string;
  buttons: string;
}

export const createUpdateProjectStylesDefault = (_theme: IH2OTheme): Partial<ICreateUpdateProjectStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  buttons: { display: 'flex', justifyContent: 'space-between', marginTop: 16 },
});
